import $http from '../../../axios-instance';
import Swal from 'sweetalert2';
import { validarPermisoComponente } from '../../../plugins/acl';

// paginación de las tablas de componentes

export async function setPagePagination({commit, dispatch}, page) {
    commit('setPageBio', parseInt(page));
    await dispatch('listarBiopersistente');
}

export async function setIarcPagination({commit, dispatch}, page) {
    commit('setPageIarc', parseInt(page));
    await dispatch('listarIarc');
}

export async function setMutaPagination({commit, dispatch}, page) {
    commit('setPageMuta', parseInt(page));
    await dispatch('listarMutagenicos');
}

export async function setReproPagination({commit, dispatch}, page) {
    commit('setPageRepro', parseInt(page));
    await dispatch('listarReprotoxicos');
}

export async function setNeuroPagination({commit, dispatch}, page) {
    commit('setPageNeuro', parseInt(page));
    await dispatch('listarNeurotoxicos');
}

export async function setOtoPagination({commit, dispatch}, page) {
    commit('setPageOtoto', parseInt(page));
    await dispatch('listarOtotoxicos');
}

export async function setScPagination({commit, dispatch}, page) {
    commit('setPageSc', parseInt(page));
    await dispatch('listarSustanciasControladas');
}

export async function setTeraPagination({commit, dispatch}, page) {
    commit('setPageTerato', parseInt(page));
    await dispatch('listarTerarogenicos');
}

export async function setTlvPagination({commit, dispatch}, page) {
    commit('setPageTlv', parseInt(page));
    await dispatch('listarTlv');
}

// Biopersistente
export async function listarBiopersistente({state, commit}, requestParameters = {params: state.params_bio}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/lista-biopersistente', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setbiopersistentes', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearBioPersistente({state, commit, dispatch}) {
    await $http.post('adm_productos/cas/biopersistente/crear', state.selectedBiopersistente)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarBiopersistente');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearBioPersistenteMasivo({state, commit, dispatch}, data) {
    await $http.post('adm_productos/cas/biopersistente/sembrar', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarBiopersistente');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verBiopersistente({state, commit}, id) {
    await $http.get(`adm_productos/cas/biopersistente/ver/${id}`)
        .then((response) => {

            commit('setBiopersistente', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });


}

export async function editarBiopersistente({state, dispatch, commit}, id) {
    await $http.put(`adm_productos/cas/biopersistente/editar/${id}`, state.selectedBiopersistente)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            commit('setAccion', 'crear');
            await dispatch('listarBiopersistente');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

export async function eliminarBiopersistente({state, dispatch}, id) {
    await $http.delete(`adm_productos/cas/biopersistente/inactivar/${id}`)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarBiopersistente');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}


//Iarc
export async function listarIarc({state, commit}, requestParameters = {params: state.params_iarc}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/lista-iarc', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setIarcs', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearIarc({state, commit, dispatch}) {
    await $http.post('adm_productos/cas/iarc/crear', state.selectedIarc)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarIarc');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function setPerPagePaginationBio({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    await dispatch('listarBiopersistente');
}

export async function setPerPagePaginationIarc({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    await dispatch('listarIarc');
}

export async function setPerPagePaginationMutagenico({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    await dispatch('listarMutagenicos');
}

export async function setPerPagePaginationNeuro({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    await dispatch('listarNeurotoxicos');
}

export async function setPerPagePaginationOtotoxicos({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    await dispatch('listarOtotoxicos');
}

export async function setPerPagePaginationReprotoxico({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    await dispatch('listarReprotoxicos');
}

export async function setPerPagePaginationSustancias({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    await dispatch('listarSustanciasControladas');
}

export async function setPerPagePaginationTerato({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    await dispatch('listarTerarogenicos');
}

export async function setPerPagePaginationTlv({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    await dispatch('listarTlv');
}

export async function verIarc({state, commit}, id) {
    await $http.get(`adm_productos/cas/iarc/ver/${id}`)
        .then((response) => {

            commit('setIarc', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });


}

export async function editarIarc({state, dispatch, commit}, id) {
    await $http.put(`adm_productos/cas/iarc/editar/${id}`, state.selectedIarc)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            commit('setAccion', 'crear');
            await dispatch('listarIarc');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

export async function eliminarIarc({state, dispatch}, id) {
    await $http.delete(`adm_productos/cas/iarc/inactivar/${id}`)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarIarc');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}


//Mutagenicos
export async function listarMutagenicos({state, commit}, requestParameters = {params: state.params_muta}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/lista-mutagenico', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setMutagenicos', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearMutagenico({state, commit, dispatch}) {
    await $http.post('adm_productos/cas/mutagenico/crear', state.selectedMutagenico)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarMutagenicos');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearMutagenicoMasivo({state, commit, dispatch}, data) {
    await $http.post('adm_productos/cas/mutagenico/sembrar', data, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarMutagenicos');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verMutagenico({state, commit}, id) {
    await $http.get(`adm_productos/cas/mutagenico/ver/${id}`)
        .then((response) => {

            commit('setMutagenico', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });


}

export async function editarMutagenico({state, dispatch, commit}, id) {
    await $http.put(`adm_productos/cas/mutagenico/editar/${id}`, state.selectedMutagenico)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            commit('setAccion', 'crear');
            await dispatch('listarMutagenicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

export async function eliminarMutagenico({state, dispatch}, id) {
    await $http.delete(`adm_productos/cas/mutagenico/inactivar/${id}`)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarMutagenicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

//Neurotoxicos
export async function listarNeurotoxicos({state, commit}, requestParameters = {params: state.params_neuro}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/lista-neurotoxico', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setNeurotoxicos', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearNeurotoxico({state, commit, dispatch}) {
    await $http.post('adm_productos/cas/neurotoxico/crear', state.selectedNeurotoxico)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarNeurotoxicos');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verNeurotoxico({state, commit}, id) {
    await $http.get(`adm_productos/cas/neurotoxico/ver/${id}`)
        .then((response) => {

            commit('setNeurotoxico', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });


}

export async function editarNeurotoxico({state, dispatch, commit}, id) {
    await $http.put(`adm_productos/cas/neurotoxico/editar/${id}`, state.selectedNeurotoxico)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            commit('setAccion', 'crear');
            await dispatch('listarNeurotoxicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

export async function eliminarNeurotoxico({state, dispatch}, id) {
    await $http.delete(`adm_productos/cas/neurotoxico/inactivar/${id}`)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarNeurotoxicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

//Ototoxicos
export async function listarOtotoxicos({state, commit}, requestParameters = {params: state.params_ototo}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/lista-ototoxico', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setOtotoxicos', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearOtotoxico({state, commit, dispatch}) {
    await $http.post('adm_productos/cas/ototoxico/crear', state.selectedOtotoxico)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarOtotoxicos');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verOtotoxico({state, commit}, id) {
    await $http.get(`adm_productos/cas/ototoxico/ver/${id}`)
        .then((response) => {

            commit('setOtotoxico', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });


}

export async function editarOtotoxico({state, dispatch, commit}, id) {
    await $http.put(`adm_productos/cas/ototoxico/editar/${id}`, state.selectedOtotoxico)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            commit('setAccion', 'crear');
            await dispatch('listarOtotoxicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

export async function eliminarOtotoxico({state, dispatch}, id) {
    await $http.delete(`adm_productos/cas/ototoxico/inactivar/${id}`)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarOtotoxicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

//Reprotoxicos
export async function listarReprotoxicos({state, commit}, requestParameters = {params: state.params_repro}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/lista-reprotoxico', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setReprotoxicos', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearReprotoxico({state, commit, dispatch}) {
    await $http.post('adm_productos/cas/reprotoxico/crear', state.selectedReprotoxico)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarReprotoxicos');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearReprotoxicoMasivo({state, commit, dispatch}, data) {
    await $http.post('adm_productos/cas/reprotoxico/sembrar', data, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarReprotoxicos');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verReprotoxico({state, commit}, id) {
    await $http.get(`adm_productos/cas/reprotoxico/ver/${id}`)
        .then((response) => {

            commit('setReprotoxico', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });


}

export async function editarReprotoxico({state, dispatch, commit}, id) {
    await $http.put(`adm_productos/cas/reprotoxico/editar/${id}`, state.selectedReprotoxico)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            commit('setAccion', 'crear');
            await dispatch('listarReprotoxicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

export async function eliminarReprotoxico({state, dispatch}, id) {
    await $http.delete(`adm_productos/cas/reprotoxico/inactivar/${id}`)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarReprotoxicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}


//SustanciasControladas
export async function listarSustanciasControladas({state, commit}, requestParameters = {params: state.params_sustancia}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/lista-sustanciascontroladas', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setSustanciasControladas', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearSustanciaControlada({state, commit, dispatch}) {
    await $http.post('adm_productos/cas/sustanciascontroladas/crear', state.selectedSustanciaControlada)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarSustanciasControladas');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verSustanciaControlada({state, commit}, id) {
    await $http.get(`adm_productos/cas/sustanciascontroladas/ver/${id}`)
        .then((response) => {

            commit('setSustanciaControlada', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });


}

export async function editarSustanciaControlada({state, dispatch, commit}, id) {
    await $http.put(`adm_productos/cas/sustanciascontroladas/editar/${id}`, state.selectedSustanciaControlada)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            commit('setAccion', 'crear');
            await dispatch('listarSustanciasControladas');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

export async function eliminarSustanciaControlada({state, dispatch}, id) {
    await $http.delete(`adm_productos/cas/sustanciascontroladas/inactivar/${id}`)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarSustanciasControladas');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

//Terarogenicos
export async function listarTerarogenicos({state, commit}, requestParameters = {params: state.params_terato}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/lista-teratogenico', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setTerarogenicos', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearTeratogenico({state, commit, dispatch}) {
    await $http.post('adm_productos/cas/teratogenico/crear', state.selectedTeratogenico)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarTerarogenicos');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearTeratogenicoMasivo({state, commit, dispatch}, data) {
    await $http.post('adm_productos/cas/teratogenico/sembrar', data, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarTerarogenicos');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verTeratogenico({state, commit}, id) {
    await $http.get(`adm_productos/cas/teratogenico/ver/${id}`)
        .then((response) => {

            commit('setTeratogenico', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });


}

export async function editarTeratogenico({state, dispatch, commit}, id) {
    await $http.put(`adm_productos/cas/teratogenico/editar/${id}`, state.selectedTeratogenico)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            commit('setAccion', 'crear');
            await dispatch('listarTerarogenicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

export async function eliminarTeratogenico({state, dispatch}, id) {
    await $http.delete(`adm_productos/cas/teratogenico/inactivar/${id}`)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarTerarogenicos');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

//Tlv
export async function listarTlv({state, commit}, requestParameters = {params: state.params_tlv}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/lista-tlv', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setTlvs', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearTlv({state, commit, dispatch}) {
    await $http.post('adm_productos/cas/tlv/crear', state.selectedTlv)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('listarTlv');
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function verTlv({state, commit}, id) {
    await $http.get(`adm_productos/cas/tlv/ver/${id}`)
        .then((response) => {

            commit('setTlv', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });


}

export async function editarTlv({state, dispatch, commit}, id) {
    await $http.put(`adm_productos/cas/tlv/editar/${id}`, state.selectedTlv)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            commit('setAccion', 'crear');
            await dispatch('listarTlv');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

export async function eliminarTlv({state, dispatch}, id) {
    await $http.delete(`adm_productos/cas/tlv/inactivar/${id}`)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            await dispatch('listarTlv');
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

}

//CAS general listarTiposCas

export async function listarTiposCas({state, commit}, requestParameters = {params: state.params_caslistar}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_productos/cas/listas', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setbiopersistentes', response.data.data.biopersistente);
            commit('setIarcs', response.data.data.iarc);
            commit('setMutagenicos', response.data.data.mutagenico);
            commit('setReprotoxicos', response.data.data.reprotoxico);
            commit('setNeurotoxicos', response.data.data.neurotoxico);
            commit('setOtotoxicos', response.data.data.ototoxico);
            commit('setSustanciasControladas', response.data.data.sustanciaControlada);
            commit('setTerarogenicos', response.data.data.teratogenico);
            commit('setTlvs', response.data.data.tlv);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function listarCas({state, commit}, /* requestParameters = { params: state.params_nocas } */) {
    commit('dashboard/load', true, {root: true});
    await $http.post('adm_productos/nocas', state.params_nocas)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setCas', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearCas({state, commit}) {

    commit('dashboard/load', true, {root: true});
    await $http.post('adm_productos/nocas/crear', state.arrayCas)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.errorCas = false;
            commit('resetCas');
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function listarComponentes({state, commit}, id) {
    if (validarPermisoComponente('listar-componentes')) {
        commit('dashboard/load', true, {root: true});
        await $http.get(`adm_productos/componentes/${id}`)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setComponente', response.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    }
}

export async function mostrarComponentes({state, commit}, id, requestParameters = {params: state.filtro}) {
    if (validarPermisoComponente('visualizar-componentes')) {
        commit('dashboard/load', true, {root: true});
        await $http.get(`adm_productos/componentes/ver/${id}`, requestParameters)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setSustancias', response.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    }
}

export async function crearComponentes({state}) {
    if (validarPermisoComponente('crear-componentes')) {
        await $http.post('adm_productos/componentes/crear', state.arrayComponentes)
            .then((response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                state.errorCas = false;
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    }
}

export async function crearComponente({state}) {
    if (validarPermisoComponente('crear-componentes')) {
        await $http.post('adm_productos/componentes/crearCompo', state.selectedComponente)
            .then((response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                state.errorCas = false;
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    }
}

/**
 * Edita el cas o nombre del componente
 * @param {*} param0
 * @param {*} id
 */
export async function editarComponente({state, commit}, id) {
    if (validarPermisoComponente('editar-componentes')) {
        commit('dashboard/load', true, {root: true});
        await $http.put(`adm_productos/componentes/editar/${id}`, state.selectedCas)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                state.errorCas = false;
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    }
}

export async function editarSustancia({state}, id) {
    await $http.put(`adm_productos/nocas/editar/${id}`, state.selectedCas)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.errorCas = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function eliminarSustancia({state}, id) {
    await $http.delete(`adm_productos/nocas/inactivar/${id}`)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.errorCas = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function eliminarComponente({state, rootState}, id) {
    if (validarPermisoComponente('editar-componentes')) {
        commit('dashboard/load', true, {root: true});
        await $http.delete(`adm_productos/componentes/inactivar/${id}`)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                state.errorCas = false;
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    }
}

/**
 * Método para obtener la información de CAS de la pantalla de empresas.
 *
 * @param {*} param0
 */
export async function getListadoCas({commit, state, rootState}, id) {

    await $http.get(`adm_productos/nocas/ver/${id}`)
        .then((response) => {
            commit('setCasEmpresa', response.data);
        })
        .catch((error) => {

        });
}
